module.exports = __webpack_public_path__ + "img/Wp_2052.6df6d76e.png";